import { useSyncExternalStore } from 'react'
import type { MouseEvent } from 'react'

/**
 * 라우터 라이브러리 없이 pathname 하나로 페이지를 전환하는 최소 도구.
 * 페이지 몇 개짜리 정적 SPA용이다 — 매칭 테이블 없이 소비처가 직접 분기한다.
 * (전제: nginx가 없는 경로를 index.html로 되돌려준다 — 새로고침·직접 진입 대응)
 */

export function usePathname(): string {
  return useSyncExternalStore(subscribe, readPathname)
}

/** 새 탭 열기(⌘·Ctrl 클릭 등) 기본 동작은 살리고, 일반 좌클릭만 SPA 전환으로 바꾼다 */
export function onLinkClick(event: MouseEvent<HTMLAnchorElement>): void {
  if (event.defaultPrevented || event.button !== 0) return
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  event.preventDefault()
  navigate(event.currentTarget.getAttribute('href') ?? '/')
}

export function navigate(path: string): void {
  if (normalize(path) === readPathname()) return
  window.history.pushState(null, '', path)
  // pushState는 popstate를 발생시키지 않으므로 직접 알린다
  window.dispatchEvent(new PopStateEvent('popstate'))
  window.scrollTo(0, 0)
}

function readPathname(): string {
  return normalize(window.location.pathname)
}

/** 끝 슬래시를 지워 `/privacy/`와 `/privacy`를 같은 페이지로 본다 */
function normalize(path: string): string {
  const trimmed = path.replace(/\/+$/, '')
  return trimmed === '' ? '/' : trimmed
}

function subscribe(onChange: () => void): () => void {
  window.addEventListener('popstate', onChange)
  return () => window.removeEventListener('popstate', onChange)
}
